// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3lKAk","icon":"styles_icon__1t4Em"};